// Device-local list of orders placed on THIS device, so guests (not signed in)
// can find and track their orders without remembering the order number. Stores
// only the id + a little metadata; live status is fetched by id when tracking.
export interface RecentOrder {
  id: string;
  createdAt: number;
  total: number;
}

const KEY = "kb_recent_orders";

export function getRecentOrders(): RecentOrder[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as RecentOrder[]) : [];
  } catch {
    return [];
  }
}

export function addRecentOrder(order: { id: string; total?: number }): void {
  try {
    const list = getRecentOrders().filter((r) => r.id !== order.id);
    list.unshift({ id: order.id, createdAt: Date.now(), total: order.total ?? 0 });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 10)));
  } catch {
    /* ignore quota */
  }
}
